import React from "react";
import Container from "react-bootstrap/Container";
import {ParentContainerStyle} from "../../types";
import CreateVehicle from "../CreateVehicle";

const CreateVehiclePage: React.FC = () => {
    return(
        <Container fluid style={ParentContainerStyle}>
            <CreateVehicle/>
        </Container>
    )
}


export default CreateVehiclePage